import styled from 'styled-components';

export const TooltipCont = styled.div`
  cursor: pointer;
  ${({ theme }) => `
    display: flex;
    padding: ${theme.layout.spacing.nano} ${theme.layout.spacing.mili};
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    color: ${theme.colors.neutral.primary[0]};
    border-radius: 4px;
  `};
`;
